// Service to persist and retrieve data from session storage
// Usage: inject(DataStorageService) and use setItem/getItem
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataStorageService {
  // Save a value to sessionStorage
  public setItem(key: string, value: unknown): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  // Retrieve a value from sessionStorage
  public getItem<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  // Remove a value from sessionStorage
  public removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }
}